import React, { memo } from 'react';
import {
  ZoomableGroup,
  ComposableMap,
  Geographies,
  Geography,
} from 'react-simple-maps';

const geoUrl =
  'https://raw.githubusercontent.com/deldersveld/topojson/master/world-countries.json';



const Map = ({ setTooltipContent, subscribersByCountry }) => {
  
  const getCount = (iso_a2) => {
    if(subscribersByCountry) {
      const data = subscribersByCountry.find(({iso}) => iso === iso_a2);
      return data ? data.count : 0;
    }
    return 0;
  } 

  return (
    <>
      <ComposableMap height={320}  data-tip="" projectionConfig={{ scale: 100 }} >
        <ZoomableGroup 
        translateExtent={[
          [0, 0],
          [800, 320]
        ]}>
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map(geo => (<Geography
                  key={geo.rsmKey}
                  geography={geo}
                  onMouseEnter={() => {
                    const { 'Alpha-2': ISO_A2, name: NAME } = geo.properties;
                    setTooltipContent(`${NAME} - ${getCount(ISO_A2) || 0}`);
                  }}
                  onMouseLeave={() => {
                    setTooltipContent('');
                  }}
                  style={{
                    default: {
                      fill: `${subscribersByCountry && (getCount(geo.properties.ISO_A2) > 0) ? '#2C97DE' : '#CCCCCC' }`,
                      outline: 'none'
                    },
                    hover: {
                      fill: '#647482',
                      outline: 'none'
                    },
                    pressed: {
                      fill: '#647482',
                      outline: 'none'
                    }
                  }}
                />
              ))
            }
          </Geographies>
        </ZoomableGroup>
      </ComposableMap>
    </>
  );
};

  export default memo(Map);
